export const cuponesTipoValue = [
  { value: 'numero', label: 'Numero' },
  { value: 'porcentaje', label: 'Porcentaje %' }
];

export const cuponesTipo = [
  {
    value: 'CUPON-DAGPACKET',
    label: 'Cupon Dagpacket',
    description: 'Cupones de bienvenida',
    utilidadAfectada: ['DAGPACKET']
  },
  {
    value: 'CUPON-LICENCIATARIO',
    label: 'Cupon Licenciatario',
    description: 'Cupones que afectan la utilidad del licenciatario',
    utilidadAfectada: ['LICENCIATARIO']
  },
  {
    value: 'CUPON-COMPUESTO',
    label: 'Cupon Compuesto',
    description: 'Cupones compuestos que afectan la utilidad del licenciatario y Dagpacket',
    utilidadAfectada: ['DAGPACKET', 'LICENCIATARIO']
  }
];
